/**
 * Pending Approval Page
 * Displayed to users waiting for admin approval
 */

import { useAuth } from '@/hooks/useAuth';

export const PendingApproval = () => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="flex justify-center">
            <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center">
              <svg
                className="w-10 h-10 text-yellow-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Cuenta Pendiente de Aprobación
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Su solicitud está siendo revisada
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="text-center space-y-4">
            <div className="w-24 h-24 bg-yellow-100 rounded-full flex items-center justify-center mx-auto">
              <svg
                className="w-12 h-12 text-yellow-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>

            <h3 className="text-xl font-semibold text-gray-900">
              ¡Registro Exitoso!
            </h3>

            <p className="text-gray-600">
              Hola <strong>{user?.displayName}</strong>, su cuenta ha sido
              creada exitosamente y está pendiente de aprobación por parte de un
              administrador.
            </p>

            <div className="bg-blue-50 border border-blue-200 rounded-md p-4 text-left">
              <h4 className="font-medium text-blue-900 mb-2">
                ¿Qué sigue ahora?
              </h4>
              <ul className="text-sm text-blue-700 space-y-1">
                <li>• Un administrador revisará su solicitud</li>
                <li>• Recibirá una notificación cuando sea aprobada</li>
                <li>• Podrá acceder al sistema una vez aprobado</li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-md p-4 text-left">
              <h4 className="font-medium text-gray-900 mb-2">
                Información de su cuenta:
              </h4>
              <div className="text-sm text-gray-600 space-y-1">
                <p>
                  <span className="font-medium">Email:</span> {user?.email}
                </p>
                <p>
                  <span className="font-medium">Estado:</span>{' '}
                  <span className="px-2 py-1 bg-yellow-100 text-yellow-800 rounded-full text-xs font-medium">
                    Pendiente de aprobación
                  </span>
                </p>
                <p>
                  <span className="font-medium">Fecha de registro:</span>{' '}
                  {user?.createdAt?.toLocaleDateString('es-CR')}
                </p>
              </div>
            </div>

            <div className="pt-4">
              <button
                onClick={handleLogout}
                className="btn-secondary w-full flex justify-center py-2 px-4 text-sm font-medium"
              >
                Cerrar Sesión
              </button>
            </div>

            <p className="text-xs text-gray-500">
              Si tiene alguna pregunta, contacte al administrador del sistema.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
